/**
 * Copyright (c) ACT, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { ComponentsProps } from '@mui/material/styles';

const props: ComponentsProps = {
  MuiButton: {
    disableRipple: true,
  },
  MuiButtonBase: {
    disableRipple: true,
  },
};

export default props;
